module.exports = __webpack_public_path__ + "static-portal/img/56-1.5d92a1e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/yingyong/56-1.jpg
// module id = km1/
// module chunks = 4